/** @jsx jsx */
import React from 'react';
import { jsx } from '@compiled/react';
import { useIntl } from '@atlassian/jira-intl';
import { DonutChart as Donut } from '@atlassian/viz-platform-charts/charts';
import type { DataType } from '../../types.tsx';
import { CustomLayout } from './layout/index.tsx';
import { CustomLegend } from './legend/index.tsx';
import messages from './messages.tsx';

type Props = {
	data: DataType[];
	width: number;
};

const MAX_WIDTH = 600;

export const DonutChart = ({ data, width: initialWidth }: Props) => {
	const { formatMessage } = useIntl();

	const width = Math.min(initialWidth, MAX_WIDTH);

	return (
		<Donut<DataType>
			data={data}
			width={width}
			valueAccessor={(d) => d.value}
			labelAccessor={(d) => d.label}
			colorAccessor={(d) => d.label}
		>
			<Donut.elements.MarkLabels hide={false} />
			<Donut.elements.MetricLabel label={formatMessage(messages.centerTextLabel)} />
			<CustomLayout />
			<CustomLegend />
		</Donut>
	);
};
